import { ca } from '@cian/analytics';

import { EScrollingBlocks } from '../../constants/scrollingBlocks';

const mapIdtoLabel: { [key: string]: string } = {
  [EScrollingBlocks.MarketPrice]: 'marketPrice',
  [EScrollingBlocks.PreciseFilters]: 'preciseFilters',
  [EScrollingBlocks.AboutHome]: 'aboutHome',
  [EScrollingBlocks.OffersHistory]: 'offersHistory',
  [EScrollingBlocks.Recommendations]: 'recommendations',
};

export function trackReportItemClick(id: EScrollingBlocks) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Navigation_go',
    label: mapIdtoLabel[id],
  });
}
